import i18next from "i18next";
import intervalPlural from "i18next-intervalplural-postprocessor";
import { useTranslation } from "react-i18next";
import { Provider } from "react-redux";
import { Navigate, Route, BrowserRouter as Router, Routes } from "react-router-dom";
import packageJson from "../package.json";
import "../src/shared/styles/globalStyles.css";
import "./App.css";
import FooterWrapper from "./components/footer-widget/footerWrapper/footerWrapper";
import HeaderWrapper from "./components/header-widget/headerWrapper/headerWrapper";
import { EvmcType } from "./models/EvmcSelections";
import EvdaDepartmentsWidget from "./pages/evda/evdaDepartmentsWidget";
import EvdaEuropeWidget from "./pages/evda/evdaEuropeWidget";
import EvdaFranceWidget from "./pages/evda/evdaFranceWidget";
import EvdaPage from "./pages/evda/evdaPage";
import EvmcPage from "./pages/evmc/evmcPage";
import EvmcWidget from "./pages/evmc/evmcWidget";
import HomePage from "./pages/homePage";
import SitePlanPage from "./pages/sitePlanPage";
import StaticPage from "./pages/staticPage";
import { AppGlobalAction } from "./redux/states/appGlobalState";
import { store } from "./redux/store";
i18next.use(intervalPlural);

const App: React.FC = () => {
  // Chargement du fichier de config
  const loadConfig = async () => {
    const response = await fetch(`en/outil-interactif/7344233/config.json`);
    const data = await response.json();
    if (data.urlVideo) {
      store.dispatch(AppGlobalAction.setUrlVideo(data.urlVideo));
    }
  };
  loadConfig();

  // Set de la version de l'application dans le store
  store.dispatch(AppGlobalAction.setVersion(packageJson.version));

  const { i18n } = useTranslation();
  document.documentElement.lang = i18n.language;

  return (
    <Provider store={store}>
      <div className="App">
        <Router basename="en/outil-interactif/7344233">
          <HeaderWrapper></HeaderWrapper>
          <main className="content-main" role="main">
            <Routes>
              {/* Accueil */}
              <Route path="/" element={<HomePage />} index />

              {/* EVDA */}
              <Route path="/EVDA" element={<EvdaPage />}>
                <Route path="FRANCE" element={<EvdaFranceWidget />} index />
                <Route path="EUROPE" element={<EvdaEuropeWidget />} />
                <Route path="DEPARTMENTS" element={<EvdaDepartmentsWidget />} />
                {/* Redirection par défaut en cas de /EVDA/suite_non_vide_non_prevue_par_les_route */}
                <Route path="*" element={<Navigate to="FRANCE" replace />} />
                {/* Redirection par défaut en cas de /EVDA sans rien à la suite de l'URL */}
                <Route path="" element={<Navigate to="FRANCE" replace />} />
              </Route>

              {/* EVMC */}
              <Route path="/EVMC" element={<EvmcPage />}>
                <Route path="LIVING" element={<EvmcWidget type={EvmcType.LIVING} />} index />
                <Route path="EDUCATION" element={<EvmcWidget type={EvmcType.EDUCATION} />} />
                <Route path="CATEGORY" element={<EvmcWidget type={EvmcType.CATEGORY} />} />
                {/* Redirection par défaut en cas de /EVMC/suite_non_vide_non_prevue_par_les_routes */}
                <Route path="*" element={<Navigate to="LIVING" replace />} />
                {/* Redirection par défaut en cas de /EVMC sans rien à la suite de l'URL */}
                <Route path="" element={<Navigate to="LIVING" replace />} />
              </Route>

              {/* Pages statiques */}
              <Route path="/plan-site" element={<SitePlanPage></SitePlanPage>}></Route>

              <Route path="/static">
                <Route path="more" element={<StaticPage page={"more"} culture={i18n.language}></StaticPage>}></Route>
                <Route path="accessibility" element={<StaticPage page={"accessibility"} culture={i18n.language}></StaticPage>}></Route>
                <Route path="legal-notice" element={<StaticPage page={"legal-notice"} culture={i18n.language}></StaticPage>}></Route>
                <Route path="conditions" element={<StaticPage page={"conditions"} culture={i18n.language}></StaticPage>}></Route>
                {/* Redirection par défaut en cas de /static/suite_non_vide_non_prevue_par_les_routes */}
                <Route path="*" element={<Navigate to="/" replace />} />
                {/* Redirection par défaut en cas de /static sans rien à la suite de l'URL */}
                <Route path="" element={<Navigate to="/" replace />} />
              </Route>

              {/* Redirection par défaut */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </main>
          <FooterWrapper />
        </Router>
      </div>
    </Provider>
  );
};

export default App;
